// @ts-strict-ignore
export const tokenize = (expression, tokenized = []) => {
  expression.forEach(value => {
    if (Array.isArray(value)) {
      tokenized.push('[', ...tokenize(value), ']');
    } else {
      tokenized.push(value);
    }
  });

  return tokenized;
};


export const detokenize = (expression, i = 0, detokenized = []) => {
  let index = i;

  while (index < expression.length) {
    const value = expression[index];

    if (value === ']') {
      return [detokenized, index + 1];
    }
    if (value === '[') {
      const [innerArray, newIndex] = detokenize(expression, index + 1);
      detokenized.push(innerArray);
      index = newIndex;
    } else {
      detokenized.push(value);
      index += 1;
    }
  }

  return detokenized;
};
